import React, {useState, useEffect} from 'react';
import {Row, Col, Card, CardTitle, Button, Label} from 'reactstrap';

import SchedaIscritto from '../SchedaIscritto/FormGridFormRow';
import Clessidra from '../Clessidra.js';
import Parametri from '../../parametri';
import controllaDate from '../controllaDate';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';

const STATO_INDEFINITO = 0;
const STATO_OPERAZIONE_CORRETTA = 2;
const STATO_ERRORE_CONNESSIONE = 3;

function ReportAbbonati(props) {

  var today = new Date();
  let sMese = String(today.getMonth() + 1);
  if (sMese.length === 1) sMese = "0" + sMese;
  let sGiorno = String(today.getDate());
  if (sGiorno.length === 1) sGiorno = "0" + sGiorno;

  const dataOggi = today.getFullYear() + '-' + sMese + '-' + sGiorno;
  const dataInizioAnno = today.getFullYear() + '-01-01';

  const [statoPagina, setStatoPagina] = useState(STATO_INDEFINITO);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [dataPartenzaDefault, setDataPartenzaDefault] = useState(dataInizioAnno);
  const [dataArrivoDefault, setDataArrivoDefault] = useState(dataOggi);

  const [abbonamenti, setAbbonamenti] = useState([]);
  const [idAbbonamentiSelezionati, setIdAbbonamentiSelezionati] = useState([]);

  const [risultatoReport, setRisultatoReport] = useState({});
  const [totalePeriodo, setTotalePeriodo] = useState(0);
  const [visualizza, setVisualizza] = useState(false);

  const [risultatoNuoviAbbonati, setRisultatoNuoviAbbonati] = useState({});
  const [risultatoRientri, setRisultatoRientri] = useState({});
  const [risultatoPersi, setRisultatoPersi] = useState({});

  const [totaleNuoviAbbonatiPeriodo, setTotaleNuoviAbbonatiPeriodo] = useState(0);
  const [totaleRientriPeriodo, setTotaleRientriPeriodo] = useState(0);
  const [totalePersiPeriodo, setTotalePersiPeriodo] = useState(0);

  const [tipoElenco, setTipoElenco] = useState("");
  const [elencoPersone, setElencoPersone] = useState([]);

  const [idIscrittoAperto, setIdIscrittoAperto] = useState(null);

  useEffect(() => {
    caricaAbbonamenti();
  }, []);

  useEffect(() => {
    setVisualizza(false);
    setTotalePeriodo(0);
    setRisultatoNuoviAbbonati({});
    setRisultatoRientri({});
    setRisultatoPersi({});
    setTotaleNuoviAbbonatiPeriodo(0);
    setTotaleRientriPeriodo(0);
    setTotalePersiPeriodo(0);
    setTipoElenco("");
    setElencoPersone([]);    
  }, [dataPartenzaDefault, dataArrivoDefault, idAbbonamentiSelezionati]);

  function caricaAbbonamenti() {
    setLoading(true);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        op: "elencoAbbonamenti",
        attivi_e_archiviati: "1",
        emak: props.emak,
        sessionId: props.sessionId
      })
    };

    fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
        (valoreDiRitorno) => {
          setLoading(false);

          if (valoreDiRitorno.risultatoOperazione !== 1 && valoreDiRitorno.risultatoOperazione !== 2) {
            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            return;
          }

          if (valoreDiRitorno.risultatoOperazione === 2) {
            props.setPagina(props.PAGINE.tornaLogin);
            return;
          }

          var elenco = valoreDiRitorno.risultatoRitorno || [];
          setAbbonamenti(elenco);

          var tuttiGliId = [];
          for (var i = 0; i < elenco.length; i++) {
            tuttiGliId.push(String(elenco[i].ID));
          }
          setIdAbbonamentiSelezionati(tuttiGliId);
          setStatoPagina(STATO_OPERAZIONE_CORRETTA);
        },
        (errore) => {
          setLoading(false);
          setError(errore);
          setStatoPagina(STATO_ERRORE_CONNESSIONE);
        }
      );
  }

  function toggleAbbonamento(idAbbonamento) {
    var id = String(idAbbonamento);
    var nuovi = [].concat(idAbbonamentiSelezionati);

    if (nuovi.indexOf(id) >= 0) {
      nuovi = nuovi.filter(function(elemento) {
        return elemento !== id;
      });
    } else {
      nuovi.push(id);
    }

    setIdAbbonamentiSelezionati(nuovi);
  }

  function selezionaTutti() {
    var tuttiGliId = [];
    for (var i = 0; i < abbonamenti.length; i++) {
      tuttiGliId.push(String(abbonamenti[i].ID));
    }
    setIdAbbonamentiSelezionati(tuttiGliId);
  }

  function selezionaNessuno() {
    setIdAbbonamentiSelezionati([]);
  }

  function calcolaReport(op) {

    if (dataPartenzaDefault === "" || dataArrivoDefault === "") {
      alert("Selezionare le date di inizio e fine");
      return;
    }

    if (dataPartenzaDefault > dataArrivoDefault) {
      alert("La data iniziale non può essere successiva alla data finale");
      return;
    }

    setLoading(true);
    setVisualizza(false);
    setTipoElenco("");
    setElencoPersone([]);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        op: op,
        dataInizio: dataPartenzaDefault,
        dataFine: dataArrivoDefault,
        idAbbonamento: idAbbonamentiSelezionati,
        emak: props.emak,
        sessionId: props.sessionId
      })
    };

    fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
        (valoreDiRitorno) => {
          setLoading(false);

          if (valoreDiRitorno.risultatoOperazione !== 1 && valoreDiRitorno.risultatoOperazione !== 2) {
            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            return;
          }

          if (valoreDiRitorno.risultatoOperazione === 2) {
            props.setPagina(props.PAGINE.tornaLogin);
            return;
          }

          if (op == "reportAbbonati") {
            setRisultatoReport(valoreDiRitorno.risultatoRitorno || {});
            setTotalePeriodo(valoreDiRitorno.totalePeriodo || 0);
            setRisultatoNuoviAbbonati(valoreDiRitorno.risultatoNuoviAbbonati || {});
            setRisultatoRientri(valoreDiRitorno.risultatoRientri || {});
            setRisultatoPersi(valoreDiRitorno.risultatoPersi || {});
            setTotaleNuoviAbbonatiPeriodo(valoreDiRitorno.totaleNuoviAbbonatiPeriodo || 0);
            setTotaleRientriPeriodo(valoreDiRitorno.totaleRientriPeriodo || 0);
            setTotalePersiPeriodo(valoreDiRitorno.totalePersiPeriodo || 0);          
            setVisualizza(true);
          }

          if (op == "reportAbbonatiElencoRientri") {
            setElencoPersone(valoreDiRitorno.risultatoRitorno || []);
            setTipoElenco("rientri");
            setVisualizza(false);
          }

          if (op == "reportAbbonatiElencoPersi") {
            setElencoPersone(valoreDiRitorno.risultatoRitorno || []);
            setTipoElenco("persi");
            setVisualizza(false);
          }

        },
        (errore) => {
          setLoading(false);
          setError(errore);
          setStatoPagina(STATO_ERRORE_CONNESSIONE);
        }
      );
  }

  function isSelezionato(idAbbonamento) {
    return idAbbonamentiSelezionati.indexOf(String(idAbbonamento)) >= 0;
  }

  function renderTabellaRisultato() {
    var chiavi = Object.keys(risultatoReport || {});

    if (chiavi.length === 0) {
      return (
        <Row form className="border" style={{marginTop:10, padding:10, backgroundColor:"#fff"}}>
          <Col md="12"><b>Non risultano dati che soddisfino le condizioni impostate</b></Col>
        </Row>
      );
    }

    return (
      <div style={{marginTop:20}}>
        <Row form className="rigaTitoloTabellaReport">
          <Col md={4} className="titoloTabellaReport"><b>Mese</b></Col>
          <Col md={2} className="titoloTabellaReport"><b>Abbonati attivi</b></Col>
          <Col md={2} className="titoloTabellaReport"><b>Nuovi abbonati</b></Col>
          <Col md={2} className="titoloTabellaReport"><b>Rientri</b></Col>
          <Col md={2} className="titoloTabellaReport"><b>Persi</b></Col>
        </Row>

        {chiavi.map(function(chiave, index) {
          return (
            <Row key={index} className="rigaTabellaReport">
              <Col md={4}>{chiave}</Col>
              <Col md={2}>{risultatoReport[chiave] || 0}</Col>
              <Col md={2}>{risultatoNuoviAbbonati[chiave] || 0}</Col>
              <Col md={2}>{risultatoRientri[chiave] || 0}</Col>
              <Col md={2}>{risultatoPersi[chiave] || 0}</Col>
            </Row>
          );
        })}

        <Row form className="rigaTabellaReport">
          <Col md={4} style={{backgroundColor:"#dfd"}}><b>Abbonati nell'intero periodo</b></Col>
          <Col md={2} style={{backgroundColor:"#dfd"}}><b>{totalePeriodo}</b></Col>
          <Col md={2} style={{backgroundColor:"#dfd"}}><b>{totaleNuoviAbbonatiPeriodo}</b></Col>
          <Col md={2} style={{backgroundColor:"#dfd"}}><b>{totaleRientriPeriodo}</b></Col>
          <Col md={2} style={{backgroundColor:"#dfd"}}><b>{totalePersiPeriodo}</b></Col>
        </Row>
        <br/>
        <i>
          <b>Legenda:</b>
          <br/>
          Abbonati attivi: abbonati con un abbonamento valido, tra gli abbonamenti selezionati, nel periodo indicato
          <br/>
          Nuovi abbonati: abbonati che hanno attivato un abbonamento, tra quelli selezionati, per la prima volta nel periodo indicato
          <br/>
          Rientri: abbonati che hanno trascorso almeno 1 anno senza abbonamenti, esclusi quelli di classe "Abbonamento Annuale"
          <br/>
          Persi: abbonati che da 1 anno sono senza abbonamenti di classe diversa da "Abbonamento Annuale", non dipende dal filtro sull'abbonamento
        </i>
      </div>      
    );
  }

  function renderElencoPersone() {
    if (tipoElenco === "") return "";

    var titolo = tipoElenco === "rientri" ? "Elenco Rientri" : "Elenco Persi";

    return (
      <div style={{marginTop:20}}>
        <div className='schedaSottotitolo'>
          {titolo}
        </div>
        {tipoElenco === "rientri" && <div style={{marginBottom:5}}><i>Abbonati che hanno trascorso almeno 1 anno senza abbonamenti, esclusi quelli di classe "Abbonamento Annuale"</i></div>}
        {tipoElenco === "persi" && <div style={{marginBottom:5}}><i>Abbonati che da 1 anno sono senza abbonamenti di classe diversa da "Abbonamento Annuale", non dipende dal filtro sull'abbonamento</i></div>}

        {elencoPersone.length === 0 ? (
          <Row form className="border" style={{marginTop:10, padding:10, backgroundColor:"#fff"}}>
            <Col md="12"><b>{tipoElenco === "rientri" ? "Nessun rientro" : "Nessun iscritto perso"} nel periodo indicato</b></Col>
          </Row>
        ) : (
          <>
            <Row form className="rigaTitoloTabellaReport">
              <Col md={1} className="titoloTabellaReport"><b>#</b></Col>
              <Col md={tipoElenco === "persi"?3:4} className="titoloTabellaReport"><b>Cognome</b></Col>
              <Col md={tipoElenco === "persi"?3:4} className="titoloTabellaReport"><b>Nome</b></Col>
              <Col md={3} className="titoloTabellaReport"><b>Tessera</b></Col>
              {tipoElenco === "persi" && <Col md={2} className="titoloTabellaReport"><b>Perso dal</b></Col>}

            </Row>

            {elencoPersone.map(function(elemento, index) {
              return (
                <Row key={index} className="rigaTabellaReport">
                  <Col md={1}>{index + 1}</Col>
                  <Col md={tipoElenco === "persi"?3:4}>
                    <span
                      style={{cursor:"pointer", color:"#0056b3", textDecoration:"underline"}}
                      onClick={() => setIdIscrittoAperto(elemento.IDPERSONA)}
                    >
                      {elemento.COGNOME}
                    </span>
                  </Col>
                  <Col md={tipoElenco === "persi"?3:4}>
                    <span
                      style={{cursor:"pointer", color:"#0056b3", textDecoration:"underline"}}
                      onClick={() => setIdIscrittoAperto(elemento.IDPERSONA)}
                    >
                      {elemento.NOME}
                    </span>
                  </Col>
                  <Col md={3}>{elemento.NUMERO_TESSERA}</Col>
                  {tipoElenco === "persi" && <Col md={2}><TrasformaDateAUmano data={elemento.DATA_PERDITA}/></Col>}
                </Row>
              );
            })}
          </>
        )}
      </div>
    );
  }  

  if (idIscrittoAperto !== null) {
    return (
      <SchedaIscritto
        {...props}
        id={idIscrittoAperto}
        ope={"modifica"}
        callbackTermineModifica={() => {
          setIdIscrittoAperto(null);
        }}
        sessionId={props.sessionId}
      />
    );
  }

  return (
    <div id="cont" style={{minHeight:"100%", backgroundColor:"#F2F2F2"}}>

      {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1E_R_Abb</div> : ""}

      {statoPagina === STATO_OPERAZIONE_CORRETTA ?
        <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
          <Row>
            <Col lg="12">
              <div
                className="schedaSpazioCentrale"
                style={{height: props.dimensioniApp.yMain, overflowY:"auto", paddingBottom:20}}
              >

                <CardTitle id="titolo">
                  Report Abbonati dal&nbsp;
                  <input
                    type="date"
                    value={dataPartenzaDefault}
                    onChange={(e) => { setDataPartenzaDefault(e.target.value); }}
                  />
                  &nbsp;al&nbsp;
                  <input
                    type="date"
                    value={dataArrivoDefault}
                    onChange={(e) => { setDataArrivoDefault(e.target.value); }}
                  />
                </CardTitle>

                <Card className="main-card mb-3">
                  <div style={{padding:15}}>

                    <Row form>
                      <Col md={12}>
                        <Label><b>Abbonamenti</b></Label>
                      </Col>
                    </Row>

                    <Row form style={{marginBottom:10}}>
                      <Col md={12}>
                        <Button
                          color="secondary"
                          size="sm"
                          style={{marginRight:10}}
                          onClick={selezionaTutti}
                        >
                          Seleziona tutti
                        </Button>

                        <Button
                          color="secondary"
                          size="sm"
                          onClick={selezionaNessuno}
                        >
                          Seleziona nessuno
                        </Button>

                        <span style={{marginLeft:15}}>
                          Selezionati: <b>{idAbbonamentiSelezionati.length}</b> / {abbonamenti.length}
                        </span>
                      </Col>
                    </Row>

                    <div
                      style={{
                        border:"1px solid #ccc",
                        backgroundColor:"#fff",
                        maxHeight:"260px",
                        overflowY:"auto",
                        padding:"10px"
                      }}
                    >
                      {abbonamenti.length === 0 ?
                        <div>Nessun abbonamento presente</div>
                      :
                        abbonamenti.map(function(elemento, index) {
                          return (
                            <div
                              key={index}
                              style={{
                                padding:"6px 0",
                                borderBottom: index < abbonamenti.length - 1 ? "1px solid #eee" : ""
                              }}
                            >
                              <label style={{cursor:"pointer", width:"100%", marginBottom:0}}>
                                <input
                                  type="checkbox"
                                  checked={isSelezionato(elemento.ID)}
                                  onChange={function() { toggleAbbonamento(elemento.ID); }}
                                  style={{marginRight:8}}
                                />
                                {elemento.NOME}
                              </label>
                            </div>
                          );
                        })
                      }
                    </div>

                    <Row form style={{marginTop:15}}>
                      <Col md={12}>
                        <Button color="success" onClick={() => calcolaReport("reportAbbonati")}>
                          Calcola
                        </Button>
                        <Button color="success" onClick={() => calcolaReport("reportAbbonatiElencoRientri")} style={{marginLeft:10}}>
                          Elenco Rientri
                        </Button>
                        <Button color="success" onClick={() => calcolaReport("reportAbbonatiElencoPersi")} style={{marginLeft:10}}>
                          Elenco Persi
                        </Button>
                      </Col>
                    </Row>

                    {loading ? <div style={{backgroundColor:"#508536", color:"#FFFFFF", fontSize:20, paddingLeft:10, marginTop:10}}>ATTENDERE, CALCOLO IN CORSO...</div> : ""}
                    <Clessidra loading={loading} />
                    {visualizza && !loading ? renderTabellaRisultato() : ""}
                    {!loading ? renderElencoPersone() : ""}
                  </div>
                </Card>

              </div>
            </Col>
          </Row>
        </div>
      : ""}
    </div>
  );
}

export default ReportAbbonati;